import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a7jx8vpa3g: FaireBrandEntity = {
  token: "b_a7jx8vpa3g",
  type: "brand",
  name: "Vat19",
  avatarUrl:
    "https://cdn.faire.com/fastly/336f4c354641c05f74f5da8ac6992a453ae5cde242a1242142962b7af0b2356e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/be9e6558902bfdf8d936066425fd744d956cb0e9c3368fba647bb47418efa9bf.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/336f4c354641c05f74f5da8ac6992a453ae5cde242a1242142962b7af0b2356e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/be9e6558902bfdf8d936066425fd744d956cb0e9c3368fba647bb47418efa9bf.jpeg",
  location: "Saint Louis, MO, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 21,
  isTopShop: true,
  isInsider: true,
  description:
    'Vat19 has been known for retailing "curiously awesome" products for over 20 years. Today, we are proud to be creating the next generation of "curiously awesome" items. We would be honored to have you carry our curious products in your awesome store! \n\nWe release 50+ videos each month to our YouTube, TikTok, Facebook, and Instagram pages to help bring awareness to our products. Because our videos are viewed approximately 100 million times per month, your customers may recognize our products and want to buy them!\n\nOur products are designed in our St. Louis facility which is also home to our video production studios and warehouse.',
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:19.418Z",
    importedBy: "entity-db-cli",
  },
};
